export const deleteAccount = () => {
  const url = '/me/account_delete_request'

  const options = {
    method: 'POST',
  }

  return { url, options }
}
